import { motion } from "framer-motion";
import { Globe } from "lucide-react";
import { Badge } from "../ui/badge";

const LANGUAGES = [
  { flag: "🇺🇸", name: "English" },
  { flag: "🇸🇦", name: "العربية" },
  { flag: "🇪🇸", name: "Español" },
  { flag: "🇵🇰", name: "اردو" },
  { flag: "🇨🇳", name: "中文" },
  { flag: "🇫🇷", name: "Français" },
  { flag: "🇩🇪", name: "Deutsch" },
  { flag: "🇧🇷", name: "Português" },
  { flag: "🇯🇵", name: "日本語" },
  { flag: "🇰🇷", name: "한국어" },
  { flag: "🇮🇳", name: "हिंदी" },
  { flag: "🇷🇺", name: "Русский" }
];

/**
 * MultilingualSection Component - EXACT ORIGINAL DESIGN
 */
export default function MultilingualSection() {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <Badge className="mb-4 bg-primary/20 text-primary border-primary/30">
            <Globe className="w-3 h-3 mr-1" />
            Multilingual
          </Badge>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Speak Your Language, Reach the World
          </h2>
          
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Voice commands in 12 languages. Content generation in 40+ languages. True global marketing.
          </p>
        </motion.div>

        {/* Language Grid with Flags */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4 mb-8">
          {LANGUAGES.map((lang, index) => (
            <motion.div
              key={lang.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="glass-card rounded-xl p-4 border border-white/10 text-center hover:border-primary/30 transition-all cursor-default"
            >
              <p className="text-3xl mb-2">{lang.flag}</p>
              <p className="text-sm text-muted-foreground">{lang.name}</p>
            </motion.div>
          ))}
        </div>

        <p className="text-center text-muted-foreground">
          + 28 more languages for content generation
        </p>
      </div>
    </section>
  );
}
